import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

function AddMatch() {
  const [campeonatos, setCampeonatos] = useState([]);
  const [campeonatoId, setCampeonatoId] = useState('');
  const [time1Id, setTime1Id] = useState('');
  const [time2Id, setTime2Id] = useState('');
  const [date, setDate] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [time1Search, setTime1Search] = useState('');
  const [time2Search, setTime2Search] = useState('');
  const [time1Suggestions, setTime1Suggestions] = useState([]);
  const [time2Suggestions, setTime2Suggestions] = useState([]);

  useEffect(() => {
    const fetchCampeonatos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/wp-json/palpitex/v1/campeonatos`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setCampeonatos(response.data);
      } catch (error) {
        setError('Erro ao carregar campeonatos.');
      }
    };
    fetchCampeonatos();
  }, []);

  const searchTimes = async (term, setSuggestions) => {
    if (term.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/wp-json/palpitex/v1/times/search`, {
        params: { term },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setSuggestions(response.data);
    } catch (error) {
      setError('Erro ao buscar times.');
    }
  };

  const handleTime1Search = (e) => {
    const value = e.target.value;
    setTime1Search(value);
    searchTimes(value, setTime1Suggestions);
  };

  const handleTime2Search = (e) => {
    const value = e.target.value;
    setTime2Search(value);
    searchTimes(value, setTime2Suggestions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/wp-json/palpitex/v1/matches`,
        {
          campeonato_id: campeonatoId,
          time1_id: time1Id,
          time2_id: time2Id,
          date,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setSuccess(response.data.message);
      setCampeonatoId('');
      setTime1Id('');
      setTime2Id('');
      setDate('');
      setTime1Search('');
      setTime2Search('');
      setTime1Suggestions([]);
      setTime2Suggestions([]);
    } catch (error) {
      setError(error.response?.data?.message || 'Erro ao cadastrar jogo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h2>Cadastrar Jogo</h2>
      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}
      <form onSubmit={handleSubmit}>
        <select
          value={campeonatoId}
          onChange={(e) => setCampeonatoId(e.target.value)}
          required
        >
          <option value="">Selecione um campeonato</option>
          {campeonatos.map((campeonato) => (
            <option key={campeonato.id} value={campeonato.id}>
              {campeonato.nome} {campeonato.ano}
            </option>
          ))}
        </select>

        <div className="autocomplete">
          <input
            type="text"
            placeholder="Time 1"
            value={time1Search}
            onChange={handleTime1Search}
            required
          />
          {time1Suggestions.length > 0 && (
            <ul className="suggestions">
              {time1Suggestions.map((time) => (
                <li
                  key={time.id}
                  onClick={() => {
                    setTime1Id(time.id);
                    setTime1Search(time.nome);
                    setTime1Suggestions([]);
                  }}
                >
                  {time.nome}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="autocomplete">
          <input
            type="text"
            placeholder="Time 2"
            value={time2Search}
            onChange={handleTime2Search}
            required
          />
          {time2Suggestions.length > 0 && (
            <ul className="suggestions">
              {time2Suggestions.map((time) => (
                <li
                  key={time.id}
                  onClick={() => {
                    setTime2Id(time.id);
                    setTime2Search(time.nome);
                    setTime2Suggestions([]);
                  }}
                >
                  {time.nome}
                </li>
              ))}
            </ul>
          )}
        </div>

        <input
          type="datetime-local"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Cadastrando...' : 'Cadastrar'}
        </button>
      </form>
    </div>
  );
}

export default AddMatch;